import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DropdownUserComponent } from "../shared/dropdown-user/dropdown-user.component";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../shared/shared.module";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    DropdownUserComponent,
  ],
  exports: [FooterComponent, HeaderComponent, SidebarComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    SharedModule,
    FormsModule,
  ],
})
export class LayoutModule {}
